<template>
	<section
		class="wysiwyg"
		:class='[theme, layout_choice]'
		:style="{'--padding-top': parsedData.padding_top + 'px', '--padding-bottom': parsedData.padding_bottom + 'px', '--padding-top-mobile': parsedData.padding_top_mobile + 'px', '--padding-bottom-mobile': parsedData.padding_bottom_mobile + 'px'}"
	>
		<div
			class="container"
			:style="{'--list-image': 'url(' + list_image + ')'}"
		>
			<div
				class='title'
				v-if='title'
				:class='[theme, layout_choice]'
			>
				<h2 v-html='title'></h2>
			</div>
			<div
				class="wysiwyg__inner"
				:class='[theme, layout_choice]'
			>

				<span
					v-if='wysiwyg'
					v-html="wysiwyg"
					class="body"
				></span>

				<div
					class="cta_wrapper"
					:class="{'no_body': !wysiwyg}"
					v-if="parsedPrimaryCta || parsedSecondaryCta"
				>
					<secondary-button
						v-if="parsedPrimaryCta"
						:label="parsedPrimaryCta.title"
						:link="parsedPrimaryCta"
						:class="[theme, layout_choice]"
						:theme="{'reverse': theme === 'blue'}"
					></secondary-button>

					<tertiary-button
						v-if="parsedSecondaryCta"
						:label="parsedSecondaryCta.title"
						:link="parsedSecondaryCta"
						:class="[theme, layout_choice]"
						:theme="{'reverse': theme === 'blue'}"
					></tertiary-button>
				</div>

			</div>

		</div>

	</section>
</template>

<script>
import SecondaryButton from './SecondaryButton.vue';
import ListImage from '../../images/chevron-right.svg';
import TertiaryButton from './TertiaryButton.vue';

export default {
	data() {
		return {
			list_image: ListImage,
		};
	},

	props: {
		section_id: {},
		top_border: {},
		wysiwyg: {},
		primary_cta: {},
		secondary_cta: {},
		title: {},
		theme: {},
		layout_choice: {},
		data: {},
	},

	computed: {
		parsedPrimaryCta() {
			if (this.primary_cta) {
				return JSON.parse(this.primary_cta);
			} else {
				return null;
			}
		},

		parsedSecondaryCta() {
			if (this.secondary_cta) {
				return JSON.parse(this.secondary_cta);
			} else {
				return null;
			}
		},

		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {
		SecondaryButton,
		TertiaryButton,
	},

	created() {},
	mounted() {
		let wysiwygIcons = document.querySelectorAll('.wysiwyg_icon');

		wysiwygIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
</style>
